import * as React from 'react';
import { Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { IWidget } from 'common/schema/widget/Widget';
import { WidgetGraphicMultilineText } from '../helper/WidgetGraphicMultilineText';
import { MarkdownRenderView } from 'client/core/markdown/render/MarkdownRenderView';
import { QuillHtmlRenderView } from 'client/core/html/render/QuillHtmlRenderView';

export interface FormWidgetGraphicTextViewProps {
  widget: IWidget;
}

export function FormWidgetGraphicTextView(
  props: FormWidgetGraphicTextViewProps
) {
  return (
    <Paragraph style={{ marginBottom: '1em' }}>
      <QuillHtmlRenderView content={props.widget.graphic!.content} />
    </Paragraph>
  );
}
